import { Directive, HostListener, Input } from '@angular/core';
import { HelpManualService } from '../services/help-manual.service';

@Directive({
  selector: '[appHelpManual]',
})
export class HelpManualOpenDirective {
  @Input() topic: string;

  @HostListener('keydown.f1', ['$event'])
  public onListenerTriggered(event: any): void {
    event.stopImmediatePropagation();
    window.open(HelpManualService.getUrl(this.topic));
  }
}
